module.exports = __webpack_public_path__ + "static/media/logo-cloud-text-hight.cda47bfd.png";